import { axiosInstance } from '@services/base-service';

const transactionsUri = '/merchant/bff/transactions';

const buildAdvancementsUrl = () => `${transactionsUri}/merchants/advancements`;

const buildAdvancementsStatusUrl = (advancementRequestId) =>
  `${transactionsUri}/merchants/advancements/${advancementRequestId}`;

const buildAdvancementsNotificationUrl = (advancementRequestId) =>
  `${transactionsUri}/merchants/advancements/notification/${advancementRequestId}`;

export const getAdvancementSimulation = async () =>
  axiosInstance.getInstance().get(buildAdvancementsUrl());

export const getAdvancementStatus = async (advancementRequestId) =>
  axiosInstance.getInstance().get(buildAdvancementsStatusUrl(advancementRequestId));

export const doAdvancement = async (liquidationAmount) => {
  const payload = { payload: { amount: liquidationAmount } };

  return axiosInstance.getInstance().post(buildAdvancementsUrl(), payload);
};

export const postAdvancementNotification = async (advancementRequestId) =>
  axiosInstance.getInstance().post(buildAdvancementsNotificationUrl(advancementRequestId), {});

export const getAdvancementDetail = (merchantId, transactionId, creditorAccountId) =>
  axiosInstance
    .getInstance()
    .get(
      `${transactionsUri}/merchants/advancements/${merchantId}/${transactionId}/${creditorAccountId}`
    );
